import { BitrixVue } from 'ui.vue';

BitrixVue.component('AdditionalButton', {
	props: ['state', 'title'],
	template: `
		<div class="additional-btn" @click="$emit('setInnerVisibility')">{{this.title}}</div>
`,
});
